export default __webpack_public_path__ + "static/media/logo-war-token.ecbb04c8.png";